/**
 * WOW Section Carousel Component with Swiper
 */
import { Swiper } from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
// Не импортируем CSS напрямую, используем наши SCSS стили

export class WowCarousel {
  constructor() {
    this.carousel = document.querySelector('[data-js="wow-carousel"]');
    this.dots = [];
    this.swiper = null;
    this.autoplayDelay = 5000; // 5 seconds
    
    if (!this.carousel) return;
    
    this.init();
  }

  init() {
    // Получаем точки навигации
    this.dots = document.querySelectorAll('.wow-section__carousel-dot');
    
    // Загружаем изображения
    this.loadImages();
    
    // Инициализируем Swiper
    this.initSwiper();
    
    // Привязываем события к точкам навигации
    this.bindDotEvents();
  }

  loadImages() {
    // Теперь изображения используют src напрямую, поэтому этот метод не нужен
    // Но оставляем для совместимости
  }

  initSwiper() {
    this.swiper = new Swiper(this.carousel, {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 800,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: this.autoplayDelay,
        disableOnInteraction: false,
      },
      on: {
        init: (swiper) => {
          this.updateDots(swiper.realIndex);
        },
        slideChange: (swiper) => {
          this.updateDots(swiper.realIndex);
        }
      }
    });
  }

  bindDotEvents() {
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const slideIndex = parseInt(dot.dataset.slide, 10);
        this.swiper.slideTo(slideIndex);
      });
    });
  }

  updateDots(activeIndex) {
    this.dots.forEach(dot => {
      dot.classList.remove('wow-section__carousel-dot--active');
    });
    
    // Активируем соответствующую точку
    if (this.dots[activeIndex]) {
      this.dots[activeIndex].classList.add('wow-section__carousel-dot--active');
    }
  }
}
